<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{ version }}</span>
    <em
      class="blue_plus"
      ref="btnShow"
      v-b-modal.agregarTratamientos
      v-b-tooltip.hover
      title="Agregar tratamientos"
    ></em>
    <b-modal
      hide-footer
      title="Agregar tratamientos"
      size="xl"
      id="agregarTratamientos"
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-row>
        <b-col>
          <b-card
            header="Selecciona un doctor"
            header-tag="header"
            title=""
            align="left"
          >
            <b-card-body class="scroll">
              <b-table-simple
                hover
                small
                caption-top
                responsive
                v-if="!loaderDoctores"
              >
                <b-thead>
                  <b-tr>
                    <b-th>Selecciona</b-th>
                    <b-th>Nombre del doctor</b-th>
                    <b-th>Especialidades</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr v-for="doctor of lstDoctores" :key="doctor.idEmpleado">
                    <b-td>
                      <b-form-radio
                        name="seleciona_doctor"
                        :value="doctor.idEmpleado"
                        v-on:change="selectDoctor(+$event)"
                        v-model="idDoctor"
                      ></b-form-radio>
                    </b-td>
                    <b-td>{{ doctor.nombreEmpleado }}</b-td>
                    <b-td v-if="doctor.especialidades.length !== 0">
                      <span
                        v-for="esp of doctor.especialidades"
                        :key="esp.idEspecialidad"
                        >{{ esp.nombreEspecialidad }}
                        <span v-if="doctor.especialidades.length > 1">,</span>
                      </span>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
              <div align="center" v-if="loaderDoctores">
                <b-spinner variant="primary" label="Spinning"></b-spinner>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col align="right" style="margin-top: 20px">
          <b-button
            v-if="loaderEsperar"
            class="mr-3"
            variant="outline-primary"
            size="sm"
          >
            <b-spinner disabled small></b-spinner>
          </b-button>
          <b-button-group v-else>
            <b-button
              class="mr-3"
              variant="outline-primary"
              size="sm"
              @click="modalTratamientos(idDoctor)"
            >
              <span v-if="!loaderEsperar">Nuevo Tratamiento</span>
            </b-button>
            <b-button
              variant="outline-warning"
              size="sm"
              v-on:click="abrirModal()"
              v-if="$localStorageService.can('RE_05_presup_emerg')"
            >
              <span v-if="!loaderEsperar">Presupuesto Emergente</span>
            </b-button>
            <b-button
              variant="outline-primary"
              size="sm"
              v-on:click="abrirModalInvisalign()"
              v-if="
                tratamientosProgramados.length !== 0 && checadorInvisilign()
              "
            >
              Sesiones invisalign
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>
      <!--SOLO PARA PRUEBAS, BORRAR CUANDO SE TERMINEN-->
      <b-modal
        size="xl"
        ref="presupuestoEmergenteTEST"
        title="Estas por realizar un diagnostico emergente"
        no-close-on-backdrop
        no-close-on-esc
        hide-footer
        no-fade
      >
        <b-container fluid>
          <PresupuestoEmergente
            :id-clinica="idClinica"
            :id-paciente="idPaciente"
            :id-sesion="idSesion"
            :id-empleado="idDoctor"
            :nombre-empleado="nombreEmpleado"
            v-on:speak="speakMethod($event)"
          ></PresupuestoEmergente>
        </b-container>
      </b-modal>
      <!-- -->
      <!-- Seccion tratamientos -->
      <b-modal
        size="xl"
        id="catalogo-tratamientos"
        hide-footer
        title="Tratamientos"
        no-close-on-backdrop
        no-close-on-esc
      >
        <div class="centerDiv">
          <div class="flxButons">
            <b-form-radio v-model="adultoNino" value="adulto"
              >Adulto</b-form-radio
            >
            <b-form-radio v-model="adultoNino" value="nino">Niño</b-form-radio>
            <b-form-radio v-model="adultoNino" value="mix">Mixto</b-form-radio>
          </div>
        </div>
        <b-tabs content-class="mt-3">
          <!--                SE RETIRA EN SPRINT 72, PARA NO CONFUNDIR CON KITS, "ITEM 12154"   -->
          <!--          <b-tab title="Kits / Combos" active>
            <b-input-group class="mb-2">
              <b-input-group-prepend is-text>
                <b-icon variant="primary" icon="search"></b-icon>
              </b-input-group-prepend>
              <b-form-input
                  id="filter-input"
                  v-model="filterCombos"
                  type="search"
                  placeholder="Buscar"
              ></b-form-input>
            </b-input-group>
            <b-table
                striped
                hover
                :filter="filterCombos"
                empty-text="Sin resultados"
                empty-filtered-text="Sin resultados"
                show-empty
                :items="paquetesArray"
                :fields="fieldsPaquetes"
                responsive="sm"
                sticky-header="true"
                class="tableCss"
            >
              <template #cell(agregar)="row">
                <b-button
                    variant="primary"
                    @click="kitsAgregarQuitar(row.item.idKit, 'agregar', row.item)"
                ><em class="fa fa-plus-square"></em
                ></b-button>
              </template>
              <template #cell(quitar)="row">
                <b-button
                    variant="primary"
                    @click="kitsAgregarQuitar(row.item.idKit, 'quitar', row.item)"
                ><em class="fa fa-minus-square"></em
                ></b-button>
              </template>
            </b-table>
            <div align="center" v-if="loaderKitsCombosAdicionales">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
            </div>
            <b v-if="paquetesArray.length === 0 && loaderKitsCombosAdicionales === false">No hay kits / combos</b>
            <div>
              <b-table
                  striped
                  hover
                  :items="kitsCombosAsesion"
                  :fields="fieldsTratamientosSesion"
                  responsive="sm"
                  sticky-header="true"
              >
              </b-table>
              <b v-if="kitsCombosAsesion.length === 0">Sin kits / combos agregados</b>
            </div>
          </b-tab>-->

          <b-tab title="Tratamientos fuera de plan">
            <div class="flxDivs">
              <div class="veintePercent">
                <b-table
                  striped
                  hover
                  :items="especialidades"
                  :fields="fieldsEspecialidades"
                  select-mode="single"
                  responsive="sm"
                  ref="selectableTable"
                  selectable
                  @row-selected="onRowSelected"
                  sticky-header="true"
                  class="tableCss"
                ></b-table>
                <div align="center" v-if="loaderEspecialidades">
                  <b-spinner variant="primary" label="Spinning"></b-spinner>
                </div>
                <b
                  v-if="
                    especialidades.length === 0 &&
                    loaderEspecialidades === false
                  "
                  >Doctor sin especialidades</b
                >
              </div>

              <div class="ochentaPercent">
                <b-input-group class="m-2">
                  <b-form-input
                    id="filter-input"
                    v-model="filterTrtsFuera"
                    placeholder="Buscar"
                    @keyup.enter="filtrarInputPrincipal"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      variant="outline-primary"
                      small
                      @click="filtrarInputPrincipal"
                      >Buscar <b-icon variant="primary" icon="search"></b-icon
                    ></b-button>
                  </b-input-group-append>
                  <b-input-group-append>
                    <b-button
                      variant="outline-secondary"
                      @click="limpiarFiltro"
                    >
                      <b-icon variant="secondary" icon="trash-fill"></b-icon
                    ></b-button>
                  </b-input-group-append>
                </b-input-group>
                <b-table
                  striped
                  hover
                  empty-text="Sin resultados"
                  empty-filtered-text="Sin resultados"
                  show-empty
                  :items="tratamientos"
                  :fields="fieldsTratamientos"
                  responsive="sm"
                  sticky-header="true"
                  class="tableCss"
                >
                  <template #cell(dientes)="row">
                    <span v-if="row.item.todosDientes === true">
                      <b-form-select
                        :id="String(row.index)"
                        v-model="row.item.diente"
                        :options="dientesCeros"
                      ></b-form-select>
                    </span>
                    <span v-else>
                      <b-form-select
                        v-model="row.item.diente"
                        :options="dientesAdultoArray"
                        v-if="adultoNino === 'adulto'"
                      ></b-form-select>
                      <b-form-select
                        v-model="row.item.diente"
                        :options="dientesNinoArray"
                        v-else-if="adultoNino === 'nino'"
                      ></b-form-select>
                      <b-form-select
                        v-model="row.item.diente"
                        :options="dientesMixArray"
                        v-else
                      ></b-form-select>
                    </span>
                  </template>

                  <template #cell(agregar)="row">
                    <b-button
                      :disabled="
                        (!row.item.todosDientes && row.item.diente == null) ||
                        row.item.loader == true
                      "
                      variant="primary"
                      @click="
                        tratamientosAgregarQuitar(
                          row.item.idTratamiento,
                          'agregar',
                          row.item,
                          row.index
                        )
                      "
                      ><div align="center" v-if="row.item.loader">
                        <b-spinner
                          small
                          variant="light"
                          label="Spinning"
                        ></b-spinner>
                      </div>
                      <em v-else class="fa fa-plus-square"></em
                    ></b-button>
                  </template>
                  <template #cell(quitar)="row">
                    <b-button
                      variant="primary"
                      @click="
                        tratamientosAgregarQuitar(
                          row.item.idTratamiento,
                          'quitar',
                          row.item
                        )
                      "
                      ><em class="fa fa-minus-square"></em
                    ></b-button>
                  </template>
                  <template #empty="scope">
                    <b-col v-if="!loaderTratamientosModal">
                      <span>Sin resultados</span>
                    </b-col>
                    <div align="center" v-if="loaderTratamientosModal">
                      <b-spinner variant="primary" label="Spinning"></b-spinner>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
            <div>
              <b-table
                striped
                hover
                :items="tratamientosAsesion"
                :fields="fieldsFueraPlan"
                responsive="sm"
                sticky-header="true"
              >
                <template v-slot:cell(nombre)="row">
                  {{ row.item.nombre }}
                </template>
                <template v-slot:cell(promo)="row">
                  <div
                    v-if="
                      row.item.promociones.filter((p) => p.seleccionado)
                        .length > 0
                    "
                  >
                    <div class="row">
                      <div v-if="row.item.promocion.descuento > 0">
                        {{ Math.round(row.item.promocion.descuento) }}%
                        descuento
                      </div>
                      <div v-else>
                        ${{ Math.round(row.item.promocion.promoDescPesos) }}
                        descuento
                      </div>
                      {{ row.item.promocion.promocion }}
                      <div>
                        <b-form-checkbox
                          class="checkbox"
                          v-b-tooltip.right
                          title="Rechazar / aceptar promoción"
                          v-if="row.item.promocion.promocionForzosa == false"
                          v-model="promoActiva"
                          name="check-button"
                          switch
                          @input="desactivarPromo(row.item)"
                        ></b-form-checkbox>
                      </div>
                    </div>
                  </div>
                  <span v-else>
                    <tag-promocion
                      :tratamiento.sync="row.item"
                      :promociones.sync="row.item.promociones"
                    ></tag-promocion>
                    <p
                      class="letrasChiquitas"
                      v-if="
                        row.item.promocion != null &&
                        row.item.promocion.promocionForzosa == false
                      "
                    >
                      {{ row.item.promocion.promocion }}
                      <em
                        class="fa fa-close botoncito"
                        @click="quitarPromo(tratamiento)"
                      ></em>
                    </p>
                    <p
                      class="letrasChiquitas"
                      v-else-if="
                        row.item.promocion != null &&
                        row.item.promocion.promocionForzosa == true
                      "
                    >
                      {{ row.item.promocion.promocion }}
                    </p>
                  </span>
                </template>
              </b-table>
              <b v-if="tratamientosAsesion.length === 0"
                >Sin tratamientos agregados</b
              >
            </div>
          </b-tab>

          <!--                SE RETIRA EN SPRINT 72, PARA NO CONFUNDIR CON KITS, "ITEM 12154"   -->
          <!--          <b-tab title="Tratamientos adicionales">
            <b-input-group class="mb-2">
              <b-input-group-prepend is-text>
                <b-icon variant="primary" icon="search"></b-icon>
              </b-input-group-prepend>
              <b-form-input
                  id="filter-input"
                  v-model="filterTrtsAdicionales"
                  type="search"
                  placeholder="Buscar"
              ></b-form-input>
            </b-input-group>
            <b-table
                striped
                hover
                :filter="filterTrtsAdicionales"
                empty-text="Doctor sin tratamientos adicionales"
                empty-filtered-text="Sin resultados"
                show-empty
                :items="tratamientosAdicionales"
                :fields="fieldsTratamientos"
                responsive="sm"
                sticky-header="true"
                class="tableCss"
            >
              <template #cell(dientes)="row">
                  <span v-if="row.item.todosDientes === true">
                    <b-form-select disabled></b-form-select>
                  </span>
                <span v-else>
                    <b-form-select
                        v-model="row.item.diente"
                        :options="dientesAdultoArray"
                        v-if="adultoNino === 'adulto'"
                    ></b-form-select>
                    <b-form-select
                        v-model="row.item.diente"
                        :options="dientesNinoArray"
                        v-else-if="adultoNino === 'nino'"
                    ></b-form-select>
                    <b-form-select
                        v-model="row.item.diente"
                        :options="dientesMixArray"
                        v-else
                    ></b-form-select>
                  </span>
              </template>
              <template #cell(agregar)="row">
                <b-button
                    :disabled="!row.item.todosDientes && row.item.diente == null"
                    variant="primary"
                    @click="
                      tratamientosAgregarQuitar(
                        row.item.idTratamiento,
                        'agregar',
                        row.item
                      )
                    "
                ><em class="fa fa-plus-square"></em
                ></b-button>
              </template>
              <template #cell(quitar)="row">
                <b-button
                    variant="primary"
                    @click="
                      tratamientosAgregarQuitar(
                        row.item.idTratamiento,
                        'quitar',
                        row.item
                      )
                    "
                ><em class="fa fa-minus-square"></em
                ></b-button>
              </template>
              <template #empty="scope">
                <b-col v-if="!loadertratamientosAdicionales">
                  <span>Sin resultados</span>
                </b-col>
                <div align="center" v-if="loadertratamientosAdicionales">
                  <b-spinner variant="primary" label="Spinning"></b-spinner>
                </div>
              </template>
            </b-table>
            <div>
              <b-table
                  striped
                  hover
                  :items="tratamientosAsesion"
                  :fields="fieldsTratamientosSesion"
                  responsive="sm"
                  head-variant="danger"
                  sticky-header="true"
              >
              </b-table>
              <b v-if="tratamientosAsesion.length === 0"
              >Sin tratamientos agregados</b
              >
            </div>
          </b-tab>-->
        </b-tabs>

        <div class="classButtons" v-if="loaderEsperar">
          <b-button
            variant="outline-primary"
            size="sm"
            @click="guardarTratamientos()"
            disabled
          >
            <b-spinner small></b-spinner>
          </b-button>
        </div>

        <div class="classButtons" v-else>
          <b-button
            variant="outline-primary"
            size="sm"
            @click="guardarTratamientos()"
            :disabled="
              tratamientosAsesion.length === 0 && kitsCombosAsesion.length === 0
            "
          >
            <span v-if="!loaderEsperar">Guardar</span>
            <b-spinner disabled small v-else></b-spinner>
          </b-button>
          <b-button
            variant="outline-danger"
            size="sm"
            @click="$bvModal.hide('catalogo-tratamientos')"
            style="margin-left: 10px"
            >Cancelar
          </b-button>
        </div>
      </b-modal>
      <!-- modal historicos -->
      <b-modal
        size="lg"
        id="presupuesto-historico"
        hide-footer
        title="El paciente cuenta con Presupuesto del Sistema V 3.0"
      >
        <div class="flxDivs modalHistoricos">
          <div class="divItemDos">
            <p>Aun así ¿Deseas crear un nuevo Tratamiento?</p>
          </div>

          <div class="divItemDos endButton">
            <router-link :to="{ name: 'paciente', params: { id: idPaciente } }">
              <b-button variant="outline-warning">
                Ver Presupuestos históricos
              </b-button>
            </router-link>
          </div>
        </div>

        <div class="classButtons">
          <b-button
            variant="outline-primary"
            size="sm"
            @click="mostrarTratamientos()"
            >Sí
          </b-button>
          <b-button
            variant="outline-danger"
            size="sm"
            @click="$bvModal.hide('presupuesto-historico')"
            style="margin-left: 10px"
            >Cancelar
          </b-button>
        </div>
      </b-modal>
      <b-modal
        size="lg"
        ref="modal-invisalign"
        title="Ajuste Sesiones Invisalign"
        no-fade
        hide-footer
      >
        <b-container fluid>
          <b-table
            striped
            hover
            empty-text="Doctor sin tratamientos adicionales"
            empty-filtered-text="Sin resultados"
            show-empty
            :items="tratamientosInvisalign"
            :fields="fieldsTratamientosInvisalign"
            responsive="sm"
            sticky-header="true"
            class="tableCss"
          >
            <template #cell(id)="row">
              <b-button
                :disabled="!row.item.id"
                variant="primary"
                @click="duplicarSesion(row.item)"
                ><em class="fa fa-plus-square"></em
              ></b-button>
            </template>
          </b-table>
        </b-container>
      </b-modal>
    </b-modal>
  </div>
</template>

<script>
import PresupuestoEmergente from "@/views/PresupuestoEmergente/presupuestoEmergente";
import _ from "lodash";
import miniToastr from "mini-toastr";
import { PromocionesService } from "../../apiServices/promociones/PromocionesService";
import { CatalogosService } from "../../apiServices/catalogos/CatalogosService";
import TagPromocion from "../../components/promocion/TagPromocion";

export default {
  components: {
    PresupuestoEmergente,
    TagPromocion,
  },
  name: "tratamientoSesionNuevo",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    catalogoservicio: new CatalogosService(),
    tratamientosInvisalign: [],
    fieldsTratamientosInvisalign: [
      { key: "tratamiento", label: "Tratamiento", sortable: false },
      { key: "id", label: "Generar otra sesión", sortable: false },
    ],
    loaderKitsCombosAdicionales: false,
    loaderEspecialidades: false,
    tratamientos: [],
    dientesAdultoArray: [],
    dientesNinoArray: [],
    dientesMixArray: [],
    selectedEspecialidad: [],
    filterTrtsAdicionales: null,
    tratamientosAdicionales: [],
    loadertratamientosAdicionales: false,
    fieldsTratamientos: [
      { key: "nombre", label: "Tratamientos", sortable: true },
      { key: "dientes", label: "OD", sortable: false },
      { key: "agregar", label: "Agregar", sortable: false },
      { key: "quitar", label: "Quitar", sortable: false },
    ],
    kitsCombosAsesion: [],
    especialidades: [],
    fieldsEspecialidades: [
      { key: "nombreEspecialidad", label: "Especialidad" },
    ],
    tratamientosAsesion: [],
    fieldsTratamientosSesion: [
      { key: "nombre", label: "Tratamiento" },
      { key: "cantidad", label: "Cantidad" },
      { key: "numeroDiente", label: "OD" },
    ],
    fieldsFueraPlan: [
      { key: "nombre", label: "Tratamiento" },
      { key: "promo", label: "Promoción" },
      { key: "cantidad", label: "Cantidad" },
      { key: "numeroDiente", label: "OD" },
    ],
    adultoNino: "adulto",
    filterCombos: null,
    paquetesArray: [],
    fieldsPaquetes: [
      { key: "nombre", label: "Tratamientos", sortable: true },
      { key: "agregar", label: "Agregar", sortable: false },
      { key: "quitar", label: "Quitar", sortable: false },
    ],
    loaderDoctores: false,
    lstDoctores: [],
    idClinica: null,
    filterTrtsFuera: null,
    loaderTratamientosModal: false,
    nombreEmpleado: null,
    idPaciente: null,
    idSesion: null,
    idDoctor: null,
    tratamientosProgramados: [],
    planSeleccionado: null,
    promocionesServicio: new PromocionesService(),
    promociones: [],
    dientesCeros: [],
    promoActiva: true,
    loaderEsperar: false,
    tratamientosOriginal: [],
  }),
  watch: {
    tratamientosProgramados: function () {
      this.checadorInvisilign();
    },
    filterTrtsFuera(newVal) {
      clearTimeout(this.$_debounceTimeoutId);
      this.$_debounceTimeoutId = null;
      if (!newVal) {
        this.filter = "";
        this.showSpinner = false;
      } else {
        this.showSpinner = true;
        this.$_debounceTimeoutId = setTimeout(() => {
          this.filter = this.searchInput;
          this.showSpinner = false;
        }, 100);
      }
    },
  },
  methods: {
    desactivarPromo(promo) {
      if (!this.promoActiva) {
        this.quitarPromo(promo);
      }
    },
    obtenerDoctoresClinica() {
      this.loaderDoctores = true;
      const parametros = { idClinica: this.idClinica };
      this.$http
        .post(this.$api + "tratamiento_sesion/listadoctoresclinica", parametros)
        .then((response) => {
          if (response.data.data) {
            this.lstDoctores = response.data.data;
            const doctor = this.lstDoctores.find(
              (em) => em.idEmpleado === this.idDoctor
            );
            this.nombreEmpleado = doctor.nombreEmpleado;
            const especialidad = doctor.especialidades
              .map((esp) => esp.nombreEspecialidad)
              .join(", ")
              .toString();
            this.$emit("nombre", this.nombreEmpleado);
            this.$emit("especialidad", especialidad);
            this.loaderDoctores = false;
          }
        })
        .catch(function () {
          this.loaderDoctores = false;
        });
    },
    selectDoctor(evento) {
      if (evento !== undefined && evento !== false) {
        this.idDoctor = evento;
        let doctor = this.lstDoctores.find(
          (item) => item.idEmpleado === this.$route.params.idDoctor
        );
        if (doctor) this.nombreEmpleado = doctor.nombreEmpleado;
      }
    },
    async obtenerPromociones() {
      await this.promocionesServicio
        .obtenerPromocionesPorPx(
          this.$localStorageService.getIdClinica(),
          this.idSesion
        )
        .then((respuesta) => {
          this.promociones = respuesta;
        });
    },
    async obtenerPromocionesPorTratamiento(idTratatamiento) {
      await this.promocionesServicio
        .obtenerPromocionesPorPxPorTx(
          this.$localStorageService.getIdClinica(),
          this.idSesion,
          idTratatamiento
        )
        .then((respuesta) => {
          this.promociones = respuesta;
        });
    },
    filtrarPromociones(item) {
      return this.promociones.filter(
        (value) =>
          value.tratmientosDescuento.filter(
            (i) => i.idTratamiento === item.idTratamiento
          ).length > 0
      );
    },
    duplicarSesion(tratamiento) {
      this.$swal.fire({
        title:
          "¿Estás seguro de crear una nueva sesion al tratamiento " +
          tratamiento.tratamiento +
          " ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          this.$http
            .post(
              this.$api +
                "tratamiento_sesion/duplicar/tratamiento?idTratamientoProgramado=" +
                tratamiento.id
            )
            .then(() => {
              this.$swal({
                icon: "success",
                title: "Se ingresó correctamente",
                showConfirmButton: false,
                timer: 2500,
                onClose: () => {},
              });
              this.$refs["modal-invisalign"].hide();
            })
            .catch((error) => {
              this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text: error.response.data.message,
              });
              this.$refs["modal-invisalign"].hide();
            });
        },
      });
    },
    mostrarTratamientos() {
      this.banderaHistoricos = false;
      this.$bvModal.hide("presupuesto-historico");
      this.modalTratamientos(this.idDoctor);
    },
    guardarTratamientos() {
      var trtsDuplicados = false;
      var nombreTrt = null;

      if (Array.isArray(this.tratamientosProgramados)) {
        this.tratamientosProgramados.forEach((element) => {
          var filtrados = this.tratamientosAsesion.filter(function (item) {
            if (item.numeroDiente === null) {
              item.numeroDiente === 59;
            }
            return (
              element.od === item.numeroDiente &&
              element.noTratamiento === item.idTratamiento
            );
          });

          if (filtrados.length !== 0) {
            trtsDuplicados = filtrados.length !== 0;
            nombreTrt = filtrados[0]["nombre"];
          }
        });
      }

      if (!trtsDuplicados) {
        this.$swal.fire({
          title: "¿Estás seguro de pasar los tratamientos a sesión?",
          text: "Importante: El tratamiento no se va a agregar si ya existe uno igual en tratamientos programados.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          showLoaderOnConfirm: true,
          preConfirm: () => {
            this.loaderEsperar = true;

            if (this.tratamientosAsesion.length !== 0) {
              let ruta =
                this.$api + "tratamiento_sesion/generarTratamientosProgramados";

              if (this.planSeleccionado !== null) {
                this.tratamientosAsesion.idPlanTratamiento =
                  this.planSeleccionado;
              }

              const params = {
                idClinica: this.$localStorageService.getIdClinica(),
                idEmpleado: this.idDoctor,
                idPaciente: this.idPaciente,
                idUsuario: this.$localStorageService.getIdUsuario(),
                tratamientos: this.tratamientosAsesion,
              };

              this.$http
                .post(ruta, params)
                .then((response) => {
                  if (response.status === 200) {
                    /*var message = response.data.message
                              ? response.data.message
                              : "Se ingresaron correctamente los tratamientos.......";
                          miniToastr.success(message);*/
                    this.$swal({
                      icon: "success",
                      title: "Se ingresaron correctamente",
                      showConfirmButton: false,
                      timer: 2500,
                    });
                    this.loaderEsperar = false;
                    this.$root.$emit("refresh");
                    this.$root.$emit(
                      "bv::hide::modal",
                      "agregarTratamientos",
                      "#btnShow"
                    );
                    this.$bvModal.hide("catalogo-tratamientos");
                  } else {
                    this.loaderEsperar = false;
                    var message = response.data.message
                      ? response.data.message
                      : "Ocurrió un error";
                    miniToastr.error(message);
                    this.$root.$emit("refresh");
                  }
                })
                .catch((error) => {
                  this.loaderEsperar = false;
                  var message = error.response.data.message
                    ? error.response.data.message
                    : "Error al pasar los tratamientos a programados";
                  miniToastr.info(message);
                })
                .finally(() => {
                  this.$emit("refresh-tratamemientos");
                });
            }

            if (this.kitsCombosAsesion.length !== 0) {
              let ruta =
                this.$api +
                "tratamiento_sesion/generarKitsProgramados?idClinica=" +
                this.$localStorageService.getIdClinica() +
                "&idUsuario=" +
                this.$localStorageService.getIdUsuario() +
                "&idPaciente=" +
                this.idPaciente +
                "&idEmpleado=" +
                this.idDoctor;
              if (this.planSeleccionado !== null) {
                ruta += "&idPlanTratamiento=" + this.planSeleccionado;
              }

              this.$http
                .post(ruta, this.kitsCombosAsesion)
                .then((response) => {
                  if (response.status === 200) {
                    var message = response.data.message
                      ? response.data.message
                      : "Se ingresaron correctamente los kits/combos";
                    miniToastr.success(message);
                  }
                })
                .catch((error) => {
                  var message = error.response.data.message
                    ? error.response.data.message
                    : "Error al pasar los kits/combos a programados";
                  miniToastr.info(message);
                });
            }
          },
          allowOutsideClick: () => !this.$swal.isLoading(),
        });
        /*.then((result) => {
              if (result.value) {
                this.$swal({
                  icon: "success",
                  title: "Se ingresaron correctamente",
                  showConfirmButton: false,
                  timer: 2500,
                });
              }
            });*/
      } else {
        this.$swal.fire({
          icon: "info",
          title: "Tratamiento duplicado",
          text:
            "El tratamiento " +
            nombreTrt +
            " ya se encuentra asignado al mismo diente",
        });
      }
    },
    onRowSelected(items) {
      this.tratamientos = [];
      this.tratamientosOriginal = [];
      this.loaderTratamientosModal = true;
      this.selectedEspecialidad = items;
      const parametros = {
        idEspecialidad: this.selectedEspecialidad[0]["idEspecialidad"],
        bandera: true,
      };
      this.$http
        .post(this.$api + "tratamientos/obtenerTratamientosNuevos", parametros)
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            this.tratamientos = response.data.data.map((it) => {
              return {
                idTratamiento: it.idTratamiento,
                nombre: it.nombre,
                cantidad: 1,
                todosDientes: it.todosDientes,
                diente: null,
                promociones: this.filtrarPromociones(it),
                loader: false,
              };
            });
            this.tratamientosOriginal = this.tratamientos;
            // this.tratamientos = _.orderBy(this.tratamientos, ['nombre'],['asc']);
          }
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(() => {
          this.loaderTratamientosModal = false;
        });
    },
    quitarPromo(promo) {
      promo.promociones.filter((p) => (p.seleccionado = false));
      promo.promocion = null;
      this.promoActiva = true;
    },

    async tratamientosAgregarQuitar(id, agregarQuitar, itm, index) {
      itm.numeroDiente = null;
      if (itm.diente == null) {
        document.getElementById(index).focus();
        miniToastr.warn(
          "El tratamiento " + itm.nombre + " no tiene un OD seleccionado."
        );
      } else {
        if (itm.diente != null) {
          itm.numeroDiente = this.dientesMixArray.find(
            (i) => i.value === itm.diente
          ).text;
        }
        if (agregarQuitar === "agregar") {
          itm.loader = true;
          //console.log(itm)
          if (
            this.tratamientosClinica.some(function (o) {
              return o["idTratamiento"] === itm["idTratamiento"];
            })
          ) {
            var tratamientoExistente = this.tratamientosAsesion.find((t) => {
              return (
                t.idTratamiento === itm.idTratamiento &&
                t.numeroDiente === itm.numeroDiente
              );
            });

            if (tratamientoExistente === undefined) {
              await this.obtenerPromocionesPorTratamiento(itm.idTratamiento);
              itm.promociones = this.filtrarPromociones(itm);
              const rep = await this.obtenerDescuentoTratamiento(
                itm.idTratamiento
              );
              itm["porcentajePlanDescuento"] = rep.descuento;
              itm["idTipoPaciente"] = rep.idTipoPaciente;
              itm["idSubTipoPaciente"] = rep.idSubTipoPaciente;
              this.tratamientosAsesion.push(JSON.parse(JSON.stringify(itm)));
              itm.promociones.forEach((c) => {
                c.seleccionado = false;
              });
              miniToastr.success("Se asignó el tratamiento");
            } else {
              miniToastr.warn("El tratamiento ya esta asignado");
            }
          } else {
            miniToastr.error(
              "La clínica " +
                this.$localStorageService.getNombreClinica() +
                " no tiene asignado este tratamiento"
            );
          }

          // this.tratamientosAsesion = _.uniqBy(
          //   this.tratamientosAsesion,
          //   "idTratamiento"
          // );
          itm.loader = false;
          console.log(itm);
        } else {
          this.tratamientosAsesion = _.filter(
            this.tratamientosAsesion,
            function (o) {
              return o.idTratamiento !== id;
            }
          );
        }
      }
    },
    kitsAgregarQuitar(id, agregarQuitar, itm) {
      if (agregarQuitar === "agregar") {
        if (this.kitsCombosAsesion.length === 0) {
          this.kitsCombosAsesion.push(itm);
          this.kitsCombosAsesion = _.uniqBy(this.kitsCombosAsesion, "idKit");
        } else {
          miniToastr.info("Solo se puede agregar un kit a sesión");
        }
      } else {
        this.kitsCombosAsesion = _.filter(this.kitsCombosAsesion, function (o) {
          return o.idKit !== id;
        });
      }
    },

    abrirModalInvisalign() {
      this.tratamientosInvisalign = this.tratamientosProgramados.filter(
        (itm) =>
          itm.noTratamiento === 335 ||
          itm.noTratamiento === 657 ||
          itm.noTratamiento === 444
      );

      this.tratamientosInvisalign = _.uniqBy(
        this.tratamientosInvisalign,
        function (e) {
          return e.tratamiento;
        }
      );

      this.$refs["modal-invisalign"].show();
    },
    checadorInvisilign() {
      var invisilign = false;
      if (this.tratamientosProgramados.length !== 0) {
        invisilign = this.tratamientosProgramados.some(
          (itm) =>
            itm.noTratamiento === 335 ||
            itm.noTratamiento === 657 ||
            itm.noTratamiento === 444
        );
      }
      return invisilign;
    },
    abrirModal() {
      this.$refs["presupuestoEmergenteTEST"].show();
    },
    speakMethod() {
      this.$refs["presupuestoEmergenteTEST"].hide();
      // this.obtenerTratamientosProgramados();
    },
    modalTratamientos(idDoctor) {
      this.idDoctor = idDoctor;
      if (!this.banderaHistoricos) {
        this.$bvModal.show("catalogo-tratamientos");
        this.getDoctoresEspecialidad(idDoctor);
        //this.getDoctoresTratamientosAdicionales(idDoctor);
        this.tratamientos = [];
        this.tratamientosAsesion = [];
        this.kitsCombosAsesion = [];
      } else {
        this.$bvModal.show("presupuesto-historico");
      }
    },
    getDoctoresEspecialidad(id) {
      this.loaderEspecialidades = true;
      this.especialidades = [];
      const parametros = { idEmpleado: id };
      this.$http
        .post(
          this.$api + "colaboradores/obtenerEspecialidadesDoctor",
          parametros
        )
        .then(async (response) => {
          if (Array.isArray(response.data.data) === true) {
            //await this.obtenerPromociones();
            this.especialidades = _.uniqBy(
              response.data.data,
              "idEspecialidad"
            );
          }
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(async () => {
          this.loaderEspecialidades = false;
        });
    },
    getDoctoresTratamientosAdicionales(id) {
      this.loadertratamientosAdicionales = true;
      this.tratamientosAdicionales = [];

      const parametros = { id: id };
      this.$http
        .post(
          this.$api + "tratamientos/obtenerTratamientosAdicionales",
          parametros
        )
        .then((response) => {
          if (Array.isArray(response.data.data) === true) {
            this.tratamientosAdicionales = response.data.data.map((it) => {
              return {
                idTratamiento: it.idTratamiento,
                nombre: it.nombreTratamiento,
                cantidad: 1,
                todosDientes: it.todosDientes,
                diente: null,
              };
            });
            this.tratamientosAdicionales = _.orderBy(
              this.tratamientosAdicionales,
              ["nombre"],
              ["asc"]
            );
          }
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(() => {
          this.loadertratamientosAdicionales = false;
        });
    },
    pacienteConProgramadosHistoricos() {
      const parametros = { idPaciente: this.idPaciente };
      this.$http
        .post(
          this.$api + "diagnostico/tratamientos/programados/paciente",
          parametros
        )
        .then((response) => {
          if (response.status === 200) {
            this.banderaHistoricos = response.data.data;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    traerSesionPlanActiva() {
      const i = new Date();
      i.setDate(i.getDate());
      i.setHours(0, 0, 0, 0);
      const inicio = this.$moment(i).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      const f = new Date();
      f.setHours(23, 59, 59, 999);
      const fin = this.$moment(f).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      const url = this.$api + "sesion/dia";
      const parametros = {
        idPaciente: this.idPaciente,
        idClinica: this.idClinica,
        horaInicio: inicio,
        horaFin: fin,
      };
      this.loadingSesion = true;
      this.$http
        .post(url, parametros)
        .then((response) => {
          let sesionDia = null;
          if (response.data.data) {
            if (this.idSesion !== undefined && this.idSesion !== null) {
              const sesionEncontrada = response.data.data.find(
                (it) =>
                  Number(it.idSesion) === Number(this.idSesionSeleccionada)
              );

              if (sesionEncontrada !== undefined) {
                sesionDia = response.data.data.find(
                  (it) => Number(it.idSesion) === Number(this.idSesion)
                );
              }
            } else {
              sesionDia = response.data.data[0];
            }
            if (sesionDia != null && sesionDia != undefined) {
              this.planSeleccionado = sesionDia.idPlan;
            }
          }
        })
        .finally(() => {
          this.loadingSesion = false;
        });
    },
    obtenerKitsCombos() {
      this.loaderKitsCombosAdicionales = true;
      this.$http
        .get(this.$api + "paquetes/obtenerPaquetes")
        .then((response) => {
          if (response.status === 200) {
            response.data.data = response.data.data.filter(function (item) {
              return item.registroActivo == true;
            });

            this.paquetesArray = response.data.data.map(function (el) {
              var o = Object.assign({}, el);
              //o.editar = "editar";
              return o;
            });
          }
          this.paquetesArray = _.orderBy(
            this.paquetesArray,
            ["nombre"],
            ["asc"]
          );
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loaderKitsCombosAdicionales = false;
        });
    },
    getDientes(tipo) {
      var url = "ptipresuntivo/obtener/catalogo/dientes";

      const params = {
        adulto: tipo == "dientesAdulto" ? true : false,
        ninio: tipo == "dientesAdulto" ? false : true,
      };
      this.$http
        .post(this.$api + url, params)
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            if (tipo == "dientesAdulto") {
              this.dientesAdultoArray = response.data.data.map(function (item) {
                var data = {
                  text: item.numeroDiente,
                  value: item.idDiente,
                };
                return data;
              });
              this.dientesAdultoArray.push({ text: "Ninguno", value: null });
            } else {
              this.dientesNinoArray = response.data.data.map(function (item) {
                var data = {
                  text: item.numeroDiente,
                  value: item.idDiente,
                };
                return data;
              });
              this.dientesNinoArray.push({ text: "Ninguno", value: null });
            }
            this.dientesMixArray = JSON.parse(
              JSON.stringify(
                this.dientesNinoArray.concat(this.dientesAdultoArray)
              )
            );
            this.dientesMixArray = this.dientesMixArray.filter(
              (itm) => itm.value != null
            );
            this.dientesMixArray.push({ text: "Ninguno", value: null });
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    obtenerTratamientosClinica() {
      const parametros = {
        idClinica: this.$localStorageService.getIdClinica(),
      };
      this.$http
        .post(this.$api + "tratamientos/obtenerTratamientosClinica", parametros)
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            this.tratamientosClinica = response.data.data.map((it) => {
              return {
                idTratamiento: it.idTratamiento,
                nombre: it.nombreTratamiento,
              };
            });
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    obtenerDientesCero() {
      this.catalogoservicio.obtenerDientesCero().then((response) => {
        this.dientesCeros = response.data.map((item) => {
          return {
            text: item.nombre,
            value: item.idDiente,
          };
        });
      });
    },
    async obtenerDescuentoTratamiento(idTx) {
      const parametros = {
        idClinica: this.idClinica,
        idPaciente: this.idPaciente,
        idTratamiento: idTx,
      };
      return await this.$http
        .post(this.$api + "presupuesto/emergente/consultar", parametros)
        .then((response) => {
          return response.data.data;
        })
        .catch(function () {
          //this.loaderDoctores = false;
        });
    },
    filtrarInputPrincipal() {
      if (
        this.filterTrtsFuera != null &&
        this.filterTrtsFuera != "" &&
        this.filterTrtsFuera != undefined
      ) {
        let lista = [];
        this.tratamientosOriginal.forEach((objeto) => {
          let existe = objeto.nombre.includes(
            this.filterTrtsFuera.toUpperCase().trim()
          );
          if (existe) {
            lista.push(objeto);
          }
        });
        this.tratamientos = lista;
      } else {
        this.tratamientos = this.tratamientosOriginal;
      }
    },
    limpiarFiltro() {
      this.filterTrtsFuera = null;
      this.tratamientos = this.tratamientosOriginal;
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.idClinica = this.$localStorageService.getIdClinica();
    this.idPaciente = +this.$route.params.idPaciente;
    this.idDoctor = +this.$route.params.idDoctor;
    this.idSesion = +this.$route.params.idSesion;
    this.nombrePaciente = this.$route.params.nombre;
    this.selectDoctor(+this.idDoctor);
    this.traerSesionPlanActiva();
    this.obtenerDientesCero();
    this.$_debounceTimeoutId = null;
  },
  beforeDestroy() {
    clearTimeout(this.$_debounceTimeoutId);
    this.$_debounceTimeoutId = null;
  },
  mounted() {
    this.obtenerDoctoresClinica();
    this.obtenerTratamientosClinica();
    this.getDientes("dientesAdulto");
    this.getDientes("dientesNino");
    this.obtenerKitsCombos();
    this.pacienteConProgramadosHistoricos();
  },
};
</script>

<style scoped>
.modalHistoricos {
  padding-bottom: 20px;
}

.endButton {
  text-align: right;
}

.classButtons {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.veintePercent {
  width: 30%;
}

.ochentaPercent {
  width: 70%;
}

.flxDivs {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.tableCss {
  max-height: 500px !important;
  min-height: 20em !important;
  overflow: auto !important;
}

.centerDiv {
  display: flex;
  justify-content: center;
}

.flxButons {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 30%;
  margin-bottom: 10px;
}

.botoncito {
  cursor: pointer;
  color: #0d0d0d;
}

.botoncito:hover {
  color: red;
}

.dropdown-menu {
  z-index: 9999 !important;
}
.checkbox {
  width: 80px !important;
  text-align: center;
  padding-left: 70px;
}
</style>
